import {Component, Input, Output, EventEmitter, trigger, state, style, transition, animate} from '@angular/core';
import {MenuController} from 'ionic-angular';

//import {CoverageService} from '../../services/coverage.service'


/*
  Generated class for the MultilevelMenu component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'multilevel-menu',
  templateUrl: 'multilevel-menu.html',
  // styleUrls: ['multilevel-menu.css'],
  animations: [
    trigger('expand', [
      state('void', style({
        height: '0px'
      })),
      transition('* => *', animate('150ms ease-in-out'))
    ])
  ]
})
export class MultilevelMenuComponent {

  @Input('categories') categories;
  @Input('selectedCategory') selectedCategory;
  @Output() onSelect = new EventEmitter();
  //selectedCategory

  //activeCat: any;
  activeSubCat: any;

  constructor(public MenuCtrl: MenuController) {
    //this.activeCat = null;
    this.activeSubCat = null;
    
    //this.selectedCategory = {}
    /*this.coverageService.getCat().subscribe(data => { 
      this.selectedCategory = data; 
      //console.log('r',data); 
    });*/

  }

  ngOnChanges(changes: any) {
    /*var width 
    if(window.innerWidth <= 576) width = this.totalwidth - 30;
    else width = (this.totalwidth - 90) / 2;

    this.elWidth = width;*/
    console.log(this.selectedCategory, 'this.selectedCategory')
    //this.container = this.container;
  }

  isActive(cat) {
    if (this.selectedCategory) {
      return cat.id == this.selectedCategory.id;
    }

    return false;
  }

  toggleCat(cat) {
    
    if (this.isCatShown(cat)) {
      //this.activeCat = null;
      this.selectedCategory = {};
    } else {
      //this.activeCat = cat;
      this.selectedCategory = cat;
    }    

    this.activeSubCat = null;// Also hide all subCats

    if (cat.items.length == 0) {
      this.triggerOnSelect(cat);
    }
  }

  isCatShown(cat) {
    
    //if (this.activeCat === cat) {
      //return true;
    //}
     if (this.selectedCategory.story==cat.story) {
      return true;
    } 
    return false;
    // console.log(this.activeCat, cat)
    //return this.activeCat === cat;
  }

  toggleSubCat(cat) {
    if (this.isSubCatShown(cat)) {
      this.activeSubCat = null;
    } else {
      this.activeSubCat = cat;
    }

    if (cat.items.length == 0) {
      this.triggerOnSelect(cat);
    }
  }

  isSubCatShown(cat) {
    return this.activeSubCat === cat;
  }

  triggerOnSelect(cat) {
    this.onSelect.emit(cat);
    this.MenuCtrl.close();
  }

}



// WEBPACK FOOTER //
// ./src/components/multilevel-menu/multilevel-menu.ts